import React, { Component } from 'react';
import routes from './routes';
import { Scaffolding } from './views';
import AppController from './utils/AppController';



import './App.css';


class App extends Component {
  render() {
  return (
  	<div>
  	<AppController />
    <Scaffolding key="scaffolding">
      <div id="outer-content" key="outer-content">
     {routes}
      </div>
    </Scaffolding>
    </div>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js